module.exports = __webpack_public_path__ + "static/img/3.1c2f3b4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/7/zh/3.png
// module id = Qn7e
// module chunks = 0